module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImageOpenData_157495235.ef0ad02c.jpg";